import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-table-no-data-message',
  templateUrl: './table-no-data-message.component.html',
  styleUrls: ['./table-no-data-message.component.scss']
})
export class TableNoDataMessageComponent {
  @Input() public data: any[] | null = null;
  @Input() public loading: boolean = false;
  @Input() public label: string = 'APP.NO_DATA_FOUND';
}
